import React, { useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import AppRoutes from "./routes";
import ClearOTPOnExit from "./component/ClearOTPOnExit";
import { openDB } from "./demo/utilities/indexedDB";
import SecureLS from "secure-ls";
import versionInfo from "./version.json";

import theme from "./theme/theme";

const ls = new SecureLS({ encodingType: "aes" });

const App = () => {
  const location = useLocation();

  useEffect(() => {
    openDB()
      .then(() => {
        console.log("IndexedDB initialized");
      })
      .catch((error) => {
        console.error("Failed to initialize IndexedDB", error);
      });
  }, []);

  const user = ls.get("user");
  const showUserName = /^\/[^/]+\/order$/.test(location.pathname);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ClearOTPOnExit />
      <AppRoutes />

      {/* App version badge */}
      <Box
        sx={{
          position: "fixed",
          bottom: 8,
          right: 8,
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          color: "white",
          padding: "6px 10px",
          borderRadius: 1,
          zIndex: 9999,
          userSelect: "none",
          fontSize: "0.75rem",
          opacity: 0.8,
          "&:hover": {
            opacity: 1,
          },
        }}
      >
        <Typography variant="caption" fontWeight="medium">
          Sparkle POS v 0.1.0 (#{versionInfo.buildNumber})
        </Typography>
        {showUserName && user && (
          <Typography
            variant="caption"
            fontWeight="regular"
            sx={{ display: "block", marginTop: "2px" }}
          >
            {user.firstname} {user.lastname}
          </Typography>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default App;
